import { useNavigate } from "react-router-dom";
import { ArrowLeft, Wifi, WifiOff, ListChecks, PenLine, ShieldCheck } from "lucide-react";
import { Logo } from "../components/Logo";
import { ConnectivityBadge } from "../lib/online";

const STEPS = [
  { icon: Wifi, title: "1. Revisa la red", text: "Verifica tu conexión Wi-Fi o datos móviles. El indicador de conexión aparece en la parte superior de las pantallas operativas." },
  { icon: WifiOff, title: "2. Reintenta", text: "El sistema reintenta automáticamente las peticiones fallidas. Los check-ins realizados sin conexión quedan en cola local y se sincronizan solos al volver el internet, sin duplicarse." },
  { icon: ListChecks, title: "3. Usa la búsqueda manual", text: "Si el sistema responde pero el escáner falla, busca al asistente por nombre, folio o teléfono y registra su acceso manualmente con motivo." },
  { icon: PenLine, title: "4. Lista física de contingencia", text: "Si el sistema no responde en absoluto, anota en papel: folio, nombre, punto de control y hora. No detengas la operación del evento." },
  { icon: ShieldCheck, title: "5. Registro posterior supervisado", text: "Al recuperar el sistema, un coordinador o administrador registra los accesos anotados usando el registro manual con motivo “Contingencia de conectividad”." },
];

const LIMITS = [
  "SÍ funciona sin conexión temporal: el check-in queda en cola local del dispositivo (datos mínimos: token/ID, punto de control, taller) y se sincroniza en orden al volver la conexión.",
  "El servidor impide duplicados aunque una operación se reintente varias veces.",
  "NO se pueden confirmar pagos, cortesías ni cambios de configuración sin conexión: esas acciones requieren respuesta del servidor.",
  "La cola local vive en el navegador del dispositivo: no borres los datos del sitio antes de sincronizar.",
];

const ContingenciaPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-hz-bg" data-testid="contingencia-page">
      <header className="border-b border-hz-gray/50 bg-white">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-4">
          <div className="flex items-center gap-3">
            <Logo variant="title" className="h-8" />
            <span className="rounded-full bg-hz-warning/10 px-3 py-1 text-xs font-bold text-hz-warning">Contingencia</span>
          </div>
          <ConnectivityBadge />
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="text-2xl font-bold tracking-tight text-hz-navy">Protocolo de contingencia del evento</h1>
        <p className="mt-2 text-sm text-hz-ink/70">
          Qué hacer ante interrupciones de internet durante la operación. Este protocolo es realista: describe exactamente qué funciona y qué no sin conexión.
        </p>
        <div className="mt-6 space-y-3">
          {STEPS.map((s) => (
            <div key={s.title} className="flex items-start gap-4 rounded-2xl border border-hz-gray/40 bg-white p-5">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-hz-cyan/10">
                <s.icon className="h-5 w-5 text-hz-cyan" />
              </div>
              <div>
                <p className="font-bold text-hz-ink">{s.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-hz-ink/70">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6 rounded-2xl border border-hz-navy/20 bg-hz-navy/5 p-5">
          <p className="text-sm font-bold text-hz-navy">Límites reales del modo sin conexión</p>
          <ul className="mt-2 list-disc space-y-1.5 pl-5 text-sm text-hz-ink/75">
            {LIMITS.map((l, i) => <li key={i}>{l}</li>)}
          </ul>
        </div>
        <button onClick={() => navigate(-1)} data-testid="contingencia-back-btn" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-hz-cyan hover:underline">
          <ArrowLeft className="h-4 w-4" /> Volver
        </button>
      </main>
    </div>
  );
};

export default ContingenciaPage;
